module.exports = __webpack_public_path__ + "img/2.6504c2c4.jpg";